<style scoped lang="less">
@import 'modal.less';

.modal-item {
  .modal-item-base();
}
</style>

<template>
  <!-- 开启手机验证 - 开始 -->
  <Modal
    v-model="vis"
    :loading="true"
    :mask-closable="false"
    @on-ok="okHandle"
    @on-cancel="cancelHandle"
    :title="$t('安全验证')"
  >
    <div class="modal-item">
      <h3>{{ $t('邮箱验证码') }}</h3>
      <div class="verify-code-box">
        <input type="text" v-model.trim="code.email" />
        <verify-code
          key="5677"
          class="verify-code"
          @click="sendEmailSms"
        ></verify-code>
      </div>
      <div class="warn-tips">
        {{ $t('输入手机') }} {{ userInfo.email | strEncrypt }}
        {{ $t('收到的验证码') }}
      </div>
    </div>
  </Modal>
  <!-- 开启手机验证 - 结束 -->
</template>

<script>
import ModalBase from '@/components/ModalBase'
// 引入 vuex 中的用户信息
import { mapState } from 'vuex'
import {
  ajaxSmsHandle,
  ajaxTry,
  updateUserInfo,
  ajaxAlert,
  ajaxTip
} from '@/utils'
import { ajax_sendEmailSms, ajax_openOrCloseSafeVerify } from '@/api/personal'

export default {
  name: 'OpenEmailVerifyModal',
  extends: ModalBase,
  computed: {
    ...mapState(['userInfo'])
  },
  inject: {
    safeVerifyInfo: 'safeVerifyInfo',
    whetherVerify: 'whetherVerify'
  },
  data() {
    return {
      code: {
        email: ''
      }
    }
  },
  mounted() {},
  methods: {
    async okHandle() {
      // 判断必要填写的验证码有没有空的，
      if (this.code.email === '') {
        this.$Message.info(this.$t('请填写邮箱验证码！'))
        return
      }
      // 发送安全验证请求
      let ajaxParam = {
        ...this.safeVerifyInfo,
        ...{
          emailCode: this.code.email
        }
      }
      let [flag] = await ajaxTry(ajax_openOrCloseSafeVerify(ajaxParam))
        .then(ajaxAlert)
        .then(updateUserInfo)
      if (flag) this.vis = false
    },
    cancelHandle() {
      // 改变外部的i-switch 状态
      let flag = this.whetherVerify[this.whetherVerify.currentISwitch]
      this.whetherVerify[this.whetherVerify.currentISwitch] = !flag
    },
    sendEmailSms($event) {
      // 发送邮箱验证码
      ajaxSmsHandle(
        ajax_sendEmailSms({
          email: this.userInfo.email,
          smstype: this.safeVerifyInfo.smstype
        }),
        $event
      ).then(ajaxTip)
    }
  }
}
</script>
